import _classCallCheck from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Base, WordArray } from './core.js';
import { SHA1Algo } from './sha1.js';
import { HMAC } from './hmac.js';
/**
 * Password-Based Key Derivation Function 2 algorithm.
 */

export var PBKDF2Algo = /*#__PURE__*/function (_Base) {
  _inherits(PBKDF2Algo, _Base);

  var _super = _createSuper(PBKDF2Algo);

  /**
   * Initializes a newly created key derivation function.
   *
   * @param {Object} cfg (Optional) The configuration options to use for the derivation.
   *
   * @example
   *
   *     const kdf = CryptoJS.algo.PBKDF2.create();
   *     const kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
   *     const kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
   */
  function PBKDF2Algo(cfg) {
    var _this;

    _classCallCheck(this, PBKDF2Algo);

    _this = _super.call(this);
    /**
     * Configuration options.
     *
     * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
     * @property {Hasher} hasher The hasher to use. Default: SHA1
     * @property {number} iterations The number of iterations to perform. Default: 1
     */

    _this.cfg = Object.assign(new Base(), {
      keySize: 128 / 32,
      hasher: SHA1Algo,
      iterations: 1
    }, cfg);
    return _this;
  }
  /**
   * Computes the Password-Based Key Derivation Function 2.
   *
   * @param {WordArray|string} password The password.
   * @param {WordArray|string} salt A salt.
   *
   * @return {WordArray} The derived key.
   *
   * @example
   *
   *     const key = kdf.compute(password, salt);
   */


  _createClass(PBKDF2Algo, [{
    key: "compute",
    value: function compute(password, salt) {
      // Shortcut
      var cfg = this.cfg; // Init HMAC

      var hmac = HMAC.create(cfg.hasher, password); // Initial values

      var derivedKey = WordArray.create();
      var blockIndex = WordArray.create([0x00000001]); // Shortcuts

      var derivedKeyWords = derivedKey.words;
      var blockIndexWords = blockIndex.words;
      var keySize = cfg.keySize,
          iterations = cfg.iterations; // Generate key

      while (derivedKeyWords.length < keySize) {
        var block = hmac.update(salt).finalize(blockIndex);
        hmac.reset(); // Shortcuts

        var blockWords = block.words;
        var blockWordsLength = blockWords.length; // Iterations

        var intermediate = block;

        for (var i = 1; i < iterations; i += 1) {
          intermediate = hmac.finalize(intermediate);
          hmac.reset(); // Shortcut

          var intermediateWords = intermediate.words; // XOR intermediate with block

          for (var j = 0; j < blockWordsLength; j += 1) {
            blockWords[j] ^= intermediateWords[j];
          }
        }

        derivedKey.concat(block);
        blockIndexWords[0] += 1;
      }

      derivedKey.sigBytes = keySize * 4;
      return derivedKey;
    }
  }]);

  return PBKDF2Algo;
}(Base);
/**
 * Computes the Password-Based Key Derivation Function 2.
 *
 * @param {WordArray|string} password The password.
 * @param {WordArray|string} salt A salt.
 * @param {Object} cfg (Optional) The configuration options to use for this computation.
 *
 * @return {WordArray} The derived key.
 *
 * @static
 *
 * @example
 *
 *     var key = CryptoJS.PBKDF2(password, salt);
 *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
 *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
 */

export var PBKDF2 = function PBKDF2(password, salt, cfg) {
  return PBKDF2Algo.create(cfg).compute(password, salt);
};